/* src/app/error/page-notfound.component.scss */
.container-fluid {
  background-color: var(--dark-gray);
  color: #E1E1E1;
  font-weight: bold;
}
a {
  color: #FFC500;
  text-decoration: none;
  font-weight: bold;
}
/*# sourceMappingURL=page-notfound.component-PRKNNNUI.css.map */
